import React from "react";
import { __ } from "@wordpress/i18n";
import { HeroSection } from "../components/hero";
import { Footer } from "../components/footer";
import { Reviews } from "../components/reviews";
import { ProPluginsBanner } from "../components/banners";
import { Section } from "../components/section";
import { Plugins } from "../components/plugins";

const Wrapper = () => {
  return (
    <div className="wpmudev-cross-sell-page">
      <div className="sui-box">
        <div className="sui-box-body">
          <HeroSection />
          <div className="sui-box">
            <div className="sui-box-body">
              <div className="cross-sell-wrapper">
                <Section>
                  <div className="cross-sell-grid">
                    <Plugins />
                  </div>
                </Section>
                <ProPluginsBanner
                  href="https://wpmudev.com/plugins/"
                  targetBlank={true}
                />
              </div>
            </div>
          </div>
          <Reviews />
          <Footer />
        </div>
      </div>
    </div>
  );
};

export { Wrapper };
